import { render, staticRenderFns } from "./TepmplateBlock.vue?vue&type=template&id=56190929&scoped=true&"
import script from "./TepmplateBlock.vue?vue&type=script&lang=js&"
export * from "./TepmplateBlock.vue?vue&type=script&lang=js&"
import style0 from "./TepmplateBlock.vue?vue&type=style&index=0&id=56190929&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56190929",
  null
  
)

export default component.exports